export default __webpack_public_path__ + "static/media/frame-highchief.91130f54.png";